import {connect} from '~/redux/connect';
import {presentSearchErrors} from "~/stateGetter";
import MessageList from "~/ui/components/MessageList/MessageList";
import {clearSearchErrors} from "~/actions/ui_actions";

const SearchMessageList = connect((state) => {
    return {
        messages: presentSearchErrors(state)
    }
}, (dispatch) => {
    return {
        hideMessages: () => dispatch(clearSearchErrors())
    }
})(MessageList);

export default SearchMessageList;